// import moment from 'moment';

// export const calculateSandwichLeaves = (leaveDates, publicHolidays = []) => {
//   if (!Array.isArray (leaveDates) || leaveDates.length === 0) {
//     return {
//       totalLeaveDays: 0,
//       isSandwichApplied: false,
//       message: 'No leave dates provided',
//       startDate: null,
//       endDate: null,
//     };
//   }

//   // Sort leave dates
//   const sortedLeaveDates = leaveDates
//     .map (d => moment (d, 'YYYY-MM-DD'))
//     .sort ((a, b) => a.diff (b));

//   // Prepare set for quick lookup of public holidays
//   const holidayDateSet = new Set (
//     publicHolidays.map (h => moment (h.date).format ('YYYY-MM-DD'))
//   );

//   // Check if the given date is the first Saturday of the month
//   const isFirstSaturday = date => {
//     return date.day () === 6 && date.date () <= 7;
//   };

//   // Helper function to check if a date is a non-working day (weekend or holiday)
//   const isNonWorkingDay = date => {
//     const day = date.day (); // 0 = Sunday, 6 = Saturday
//     const formatted = date.format ('YYYY-MM-DD');

//     if (holidayDateSet.has (formatted)) return true;
//     if (day === 0) return true; // Sunday is always non-working
//     if (day === 6 && !isFirstSaturday (date)) return true; // Saturday is non-working except first Saturday

//     return false;
//   };

//   // Step 1: Original leave range
//   const originalStart = sortedLeaveDates[0].clone ();
//   const originalEnd = sortedLeaveDates[sortedLeaveDates.length - 1].clone ();

//   // Step 2: Try to extend for sandwich
//   let extendedStart = originalStart.clone ();
//   while (true) {
//     const prevDay = extendedStart.clone ().subtract (1, 'days');
//     if (isNonWorkingDay (prevDay)) {
//       extendedStart = prevDay;
//     } else {
//       break;
//     }
//   }

//   let extendedEnd = originalEnd.clone ();
//   while (true) {
//     const nextDay = extendedEnd.clone ().add (1, 'days');
//     if (isNonWorkingDay (nextDay)) {
//       extendedEnd = nextDay;
//     } else {
//       break;
//     }
//   }

//   // Step 3: Calculate leave days for both ranges
//   const calculateDays = (start, end) => end.diff (start, 'days') + 1;

//   const extendedDays = calculateDays (extendedStart, extendedEnd);
//   const originalDays = sortedLeaveDates.length;

//   // Step 4: Apply sandwich only if more days AND total >= 4
//   const isSandwichApplied = extendedDays > originalDays && extendedDays >= 4;

//   const finalStart = isSandwichApplied ? extendedStart : originalStart;
//   const finalEnd = isSandwichApplied ? extendedEnd : originalEnd;
//   const totalLeaveDays = calculateDays (finalStart, finalEnd);

//   // Step 5: Message
//   let message = isSandwichApplied
//     ? 'Sandwich leave applied due to adjacent weekend/holiday.'
//     : 'Regular leave without sandwich effect.';

//   if (totalLeaveDays > 4) {
//     message += ` Note: Leave span is ${totalLeaveDays} days.`;
//   }

//   return {
//     totalLeaveDays,
//     isSandwichApplied,
//     startDate: finalStart.format ('MM/DD/YYYY'),
//     endDate: finalEnd.format ('MM/DD/YYYY'),
//     message,
//   };
// };

import moment from 'moment';

export const calculateSandwichLeaves = (leaveDates, publicHolidays = []) => {
  if (!Array.isArray (leaveDates) || leaveDates.length === 0) {
    return {
      totalLeaveDays: 0,
      isSandwichApplied: false,
      message: 'No leave dates provided',
      startDate: null,
      endDate: null,
    };
  }

  // Sort leave dates
  const sortedLeaveDates = leaveDates
    .map (d => moment (d, 'YYYY-MM-DD'))
    .sort ((a, b) => a.diff (b));

  // Set of public holiday dates for fast lookup
  const holidayDateSet = new Set (
    publicHolidays.map (h => moment (h.date).format ('YYYY-MM-DD'))
  );

  // Check if a date is the first Saturday of the month
  const isFirstSaturday = date => {
    return date.day () === 6 && date.date () <= 7;
  };

  // Helper: Check if date is a non-working day
  const isNonWorkingDay = date => {
    const day = date.day (); // 0 = Sunday, 6 = Saturday
    const formatted = date.format ('YYYY-MM-DD');

    if (holidayDateSet.has (formatted)) return true;
    if (day === 0) return true; // Sunday
    if (day === 6 && !isFirstSaturday (date)) return true; // Saturday except first

    return false;
  };

  // Step 1: Get original leave range
  const originalStart = sortedLeaveDates[0].clone ();
  const originalEnd = sortedLeaveDates[sortedLeaveDates.length - 1].clone ();

  // Step 2: Extend start and end to find sandwich range
  let extendedStart = originalStart.clone ();
  while (true) {
    const prevDay = extendedStart.clone ().subtract (1, 'days');
    if (isNonWorkingDay (prevDay)) {
      extendedStart = prevDay;
    } else {
      break;
    }
  }

  let extendedEnd = originalEnd.clone ();
  while (true) {
    const nextDay = extendedEnd.clone ().add (1, 'days');
    if (isNonWorkingDay (nextDay)) {
      extendedEnd = nextDay;
    } else {
      break;
    }
  }

  // Step 3: Check if sandwich rule applies
  const extendedDays = extendedEnd.diff (extendedStart, 'days') + 1;
  const originalDays = sortedLeaveDates.length;
  const isSandwichApplied = extendedDays > originalDays && extendedDays >= 4;

  // Step 4: Final deduction is based on actual leave only
  const finalStart = originalStart;
  const finalEnd = originalEnd;
  const totalLeaveDays = originalDays;

  // Step 5: Construct message
  let message = 'Regular leave without sandwich effect.';
  if (isSandwichApplied) {
    message =
      `Sandwich leave found due to adjacent weekend/holiday.\n` +
      `Effective sandwich range: ${extendedStart.format ('MM/DD/YYYY')} to ${extendedEnd.format ('MM/DD/YYYY')}\n` +
      `But only your actual leave dates from ${originalStart.format ('MM/DD/YYYY')} to ${originalEnd.format ('MM/DD/YYYY')} are counted.`;
  }

  return {
    totalLeaveDays,
    isSandwichApplied,
    startDate: finalStart.toDate (),
    endDate: finalEnd.toDate (),
    message,
  };
};
